// extracted by mini-css-extract-plugin
export default {"container":"mobile_filters-module__container--1TuKD"};